import { useCatalogRouteMatch } from '@utils/common';
import { ReviewsInCatalog } from '@components/ReviewsInCatalog';

import { useReviewsInCatalogQuery } from './gql/graphql.v5.generated';

const limitReviews = 4;

export const ReviewsInCatalogContainer: React.FC = () => {
  const match = useCatalogRouteMatch();
  const params = match?.params;
  let catalogSlug;
  if (params) {
    catalogSlug = 'slug' in params ? params.slug : params.namespace;
  }
  const { data, error } = useReviewsInCatalogQuery({
    variables: {
      catalogSlug: catalogSlug || '',
      limit: limitReviews,
    },
    skip: !catalogSlug,
    context: { v5: true },
  });

  if (error) {
    return null;
  }

  if (data?.catalogBuyerPositiveReviews) {
    return (
      <ReviewsInCatalog
        reviews={data.catalogBuyerPositiveReviews}
      />
    );
  }

  return null;
};

export default ReviewsInCatalogContainer;
